import { render, staticRenderFns } from "./ProductScreen.vue?vue&type=template&id=5e5bcc10&"
import script from "./ProductScreen.vue?vue&type=script&lang=ts&"
export * from "./ProductScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports